import Config from "@/const/Config";
import { BaseApi } from "./BaseApi";
import { DakokuDataFull, MyTaskData, SoumuDakokuCheckListRes } from "@/types/Dakoku";
import { HakenSyouninListReq, ZangyouCheckListReq, ZangyouCheckListRes, HakensakiShimeCheckData } from "@/types/MyTask";
import { DakokuWhereConditions, SoumuDakokuCheckWhereConditions, SoumuDakokuCheckRequest } from "@/types/MyTask";

export class MyTaskApi extends BaseApi {

    /**
    * 承認打刻情報を取得します
    * @returns
    */
    public async getDakokuSyouninList(params: DakokuWhereConditions): Promise<MyTaskData[] | any> {
        try {
            const res = await this.post(Config.API_URL + `/my_task/dakoku/syounin_list`, { params });
            return res.data;
        } catch (e: any) {
            throw e;
        }
    }

    /**
    * 総務が確認する打刻情報を取得します
    * @returns
    */
    public async getDakokuSoumuCheckList(params: SoumuDakokuCheckWhereConditions): Promise<SoumuDakokuCheckListRes> {
        try {
            const res = await this.post<SoumuDakokuCheckListRes>(Config.API_URL + `/my_task/dakoku/soumu_dakoku_check_list`, { params });
            return res.data;
        } catch (e: any) {
            throw e;
        }
    }

    /**
     * 総務チェックを一括登録します。
     * @param params
     * @returns 登録件数
     */
    public async updateSoumuChecks(params: SoumuDakokuCheckRequest): Promise<MyTaskData[] | any> {
        try {
            const res = await this.post(Config.API_URL + `/my_task/dakoku/update_soumu_checks`, { 'dakokuList': params });
            return res.data;
        } catch (e: any) {
            throw e;
        }
    }

    /**
     * 承認チェックを一括登録します。
     * @param params
     * @returns 登録件数
     */
    public async updateSyouninChecks(params: number[]): Promise<DakokuDataFull[] | any> {
        try {
            const res = await this.post(Config.API_URL + `/my_task/dakoku/update_syounin_checks`, { 'dakokuList': params });
            return res.data;
        } catch (e: any) {
            throw e;
        }
    }

    /**
    * 総務が確認する打刻情報を取得します
    * @returns
    */
    public async getHakenSyouninList(params: HakenSyouninListReq): Promise<MyTaskData[] | []> {
        try {
            const res = await this.post<MyTaskData[] | null>(Config.API_URL + `/my_task/dakoku/haken_syounin_list`, { params });
            return res.data ? res.data : [];
        } catch (e: any) {
            throw e;
        }
    }

    // 残業45時間以上のサマリを取得します
    public async getOver45Zangyou(params: ZangyouCheckListReq): Promise<ZangyouCheckListRes> {
        try {
            const res = await this.post<ZangyouCheckListRes>(Config.API_URL + `/my_task/kanri/over_45_list`, params);
            return res.data
        } catch (e: any) {
            console.log(e)
            throw e;
        }
    }

    /**
    * 総務が確認する派遣先上長月締め情報を取得します
    * @returns
    */
    public async getHakensakiShimeCheckList(params: HakenSyouninListReq): Promise<HakensakiShimeCheckData[] | []> {
        try {
            const res = await this.post<HakensakiShimeCheckData[] | null>(Config.API_URL + `/my_task/dakoku/hakensaki_shime_check_list`, { params });
            return res.data ? res.data : [];
        } catch (e: any) {
            throw e;
        }
    }
}
